import axios from "axios";
import paginate from "../../utils/helpers/paginate";

export const TRANSACTION_LIST_URL = "transactions/list";
export const PIRO_EXCEL_TRANSACTION_LIST_URL = "transactions/piro-excel";

const transactionService = {
  list: ({ page, limit, sort, search, bank, companyId }) => {
    let url = `${TRANSACTION_LIST_URL}?${paginate(limit, page, sort)}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (bank) {
      url += `&bankId=${bank}`;
    }
    if (companyId) {
      url += `&companyId=${companyId}`;
    }
    return axios.get(url)
  },
  list2: ({ page, limit, sort, search, bank, companyId }) => {
    let url = `https://payloadcms.piro.my.id/list-rtol-trx?${paginate(limit, page, sort)}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (bank) {
      url += `&bankId=${bank}`;
    }
    if (companyId) {
      url += `&companyId=${companyId}`;
    }
    return axios.get(url)
  },
  piroExcelList: ({ page, limit, sort, search, startDate, endDate, senderName, receiverName }) => {
    let url = `${PIRO_EXCEL_TRANSACTION_LIST_URL}?${paginate(limit, page, sort)}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    if (senderName) {
      url += `&senderName=${senderName}`;
    }
    if (receiverName) {
      url += `&receiverName=${receiverName}`;
    }
    return axios.get(url)
  }
}

export default transactionService
